export const getListFromEnum = <TItem extends string>() => {
  return <TUnion extends ReadonlyArray<TItem>>(
    list: TUnion &
      (Exclude<TItem, TUnion[number]> extends never
        ? unknown
        : 'Missing values'),
  ) => list;
};
